module.exports = __webpack_public_path__ + "static/media/WS5@2x.c9234997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WS/WS5@2x.png
// module id = 755
// module chunks = 0